import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Typography,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import "./ServiceSelectionModal.css";
import { useEffect, useState } from "react";
import api from "../../services/api";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";

export default function PatientModal({ open, onClose, selectedPatient }) {
  const [patientDetails, setPatientDetails] = useState({});
  useEffect(() => {
    if (open && selectedPatient?.id) {
      getPatientDetails();
    }
  }, [open, selectedPatient]);

  const getPatientDetails = async () => {
    try {
      let data = await api.get(
        `/app/dashboard/patient-sessions?patient_id=${selectedPatient?.id}`,
      );

      setPatientDetails(data?.data); // important
    } catch (error) {
      console.error("Error fetching patient sessions:", error);
    }
  };
  const columns = [
    {
      field: "patient_name",
      headerName: "Patient Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "day_name",
      headerName: "Day",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "session_date",
      headerName: "Session Date",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "total_session_planned",
      headerName: "Total Planned",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "attended",
      headerName: "Attended",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "notes",
      headerName: "Notes",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "exclude_from_invoice",
      headerName: "Exclude From Invoice",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
  ];
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      sx={{
        maxHeight: "70vh",
        overflowY: "auto",
      }}
    >
      <DialogTitle className="slot_dialog_title">
        Patient Sessions
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {Object.entries(patientDetails?.sessions || {}).map(
          ([month, sessions]) => {
            const rows = sessions.map((item, index) => ({
              id: index + 1,
              ...item,
            }));

            return (
              <Box key={month} mb={4}>
                <Typography
                  variant="h6"
                  sx={{
                    background: "#4747a12e",
                    p: 0.5,
                    borderRadius: 1,
                    mb: 1,
                    fontWeight: 600,
                    fontFamily: "Nunito, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {month}
                </Typography>

                <DataGrid
                  sx={{
                    fontFamily: "Nunito, sans-serif",
                    "& .MuiDataGrid-cell": {
                      fontSize: "12px",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "13px",
                      fontWeight: "bold",
                    },
                  }}
                  rows={rows}
                  columns={columns}
                  autoHeight
                  hideFooter
                  disableRowSelectionOnClick
                />
              </Box>
            );
          },
        )}
      </DialogContent>
    </Dialog>
  );
}
